import BackNavigationArrow from "@/components/views/BackNavigationArrow";
import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { URLQuery } from "@/utils/queryUtils";
import { Card, Input } from "antd";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { RealtyCalcDraftTableView } from "../components/RealtyCalcDraftTableView";
import { TravelCalcDraftTableView } from "../components/TravelCalcDraftTableView";
import { VehicleCalcDraftTableView } from "../components/VehicleCalcDraftTableView";

const getTitleAndContent = (type: "vehicle" | "realty" | "travel") => {
  let tableContent;
  let pageTitle;

  switch (type) {
    case "vehicle":
      tableContent = <VehicleCalcDraftTableView />;
      pageTitle = t("calc.draft.titles.vehicleList");
      break;
    case "realty":
      tableContent = <RealtyCalcDraftTableView />;
      pageTitle = t("calc.draft.titles.realtyList");
      break;
    case "travel":
      tableContent = <TravelCalcDraftTableView />;
      pageTitle = t("calc.draft.titles.travelList");
      break;
  }

  return { tableContent, pageTitle };
};

type Props = {
  type: "vehicle" | "realty" | "travel";
};

export const CalcDraftListContainer = ({ type }: Props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const keywordSearchParam = useFilterSearchParams().keyword;

  const handleSearchSubmit = (value: string) => {
    navigate(
      {
        search: URLQuery.searchParamsToString({ searchParams: { keyword: value, pageIndex: undefined }, append: true }),
      },
      { replace: true },
    );
  };

  const data = getTitleAndContent(type);

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={
          <BackNavigationArrow>
            <h2>{data.pageTitle}</h2>
          </BackNavigationArrow>
        }
        extra={
          <Input.Search
            style={{ width: 350 }}
            enterButton
            allowClear
            placeholder={t("calc.draft.helpers.searchHint")}
            defaultValue={keywordSearchParam}
            onSearch={handleSearchSubmit}
          />
        }
      >
        {data.tableContent}
      </Card>
    </ContentWrapper>
  );
};
